import React from 'react';
import styles from './styles.module.scss';

const Badge = ({ text }) => <span className={styles.badge}>{text}</span>;

export default Badge;
